export default {"src":"/_next/static/media/solvar_01.0b1cfb89.svg","height":246,"width":1102,"blurWidth":0,"blurHeight":0};